export default "__VITE_ASSET__CplA7nE2__"